import { useState } from "react";
import { Input } from "@/components/ui/input";
import { X } from "lucide-react";

export default function TagsInput({ value = [], onChange, placeholder = "Ketik nama lalu tekan Enter" }) {
  const [text, setText] = useState("");

  const addTag = (raw) => {
    const t = raw.trim();
    if (!t) return;
    if (value.includes(t)) {
      setText("");
      return;
    }
    onChange([...value, t]);
    setText("");
  };

  const removeTag = (idx) => {
    onChange(value.filter((_, i) => i !== idx));
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(text);
    } else if (e.key === "Backspace" && text === "" && value.length > 0) {
      removeTag(value.length - 1);
    }
  };

  return (
    <div className="border border-black bg-white p-2 flex flex-wrap gap-2 min-h-[44px]">
      {value.map((tag, idx) => (
        <span
          key={idx}
          data-testid={`tag-${idx}`}
          className="inline-flex items-center gap-1 bg-black text-white px-2 py-1 text-xs font-medium"
        >
          {tag}
          <button
            type="button"
            data-testid={`tag-remove-${idx}`}
            onClick={() => removeTag(idx)}
            className="hover:opacity-70"
            aria-label={`Hapus ${tag}`}
          >
            <X size={12} />
          </button>
        </span>
      ))}
      <Input
        data-testid="tags-input-field"
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => addTag(text)}
        placeholder={value.length === 0 ? placeholder : ""}
        className="flex-1 min-w-[120px] border-0 shadow-none focus-visible:ring-0 px-1 h-8"
      />
    </div>
  );
}
